// pages/NotificacaoWhatsapp.js
"use client"

import { useState } from "react"
import axios from "axios"
import "../styles/taxasAdmin.css"
import { FaWhatsapp, FaPaperPlane } from "react-icons/fa"

const NotificacaoWhatsapp = () => {
  const [pedidoId, setPedidoId] = useState("")
  const [loading, setLoading] = useState(false)
  const [mensagem, setMensagem] = useState("")

  const enviarNotificacao = async () => {
    if (!pedidoId) {
      setMensagem("⚠ Informe o ID do pedido.")
      return
    }

    try {
      setLoading(true)
      setMensagem("")
      const token = localStorage.getItem("token")

      const resp = await axios.post(
        "https://api.ticketdovaqueiro.com/api/testezapi/testar-envio-zapi",
        { pedidoId },
        { headers: { Authorization: `Bearer ${token}` } }
        );

      if (resp.data.success) {
        setMensagem("✅ Mensagens enviadas com sucesso via WhatsApp (Z-API)!")
      } else {
        setMensagem("❌ Não foi possível enviar as mensagens.")
      }
    } catch (err) {
      console.error("Erro ao enviar notificação:", err)
      setMensagem("❌ Erro no envio. Verifique o ID do pedido e tente novamente.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="taxas-admin-container">
      <h2>
        <FaWhatsapp style={{ marginRight: 10 }} />
        Notificação WhatsApp
      </h2>
      <p>Envie manualmente o comprovante de pagamento de um pedido via WhatsApp.</p>

      <div className="taxa-form">
        <div className="form-group">
          <label>ID do Pedido</label>
          <input
            type="text"
            value={pedidoId}
            onChange={(e) => setPedidoId(e.target.value)}
            placeholder="Ex: 68bee768b7ab48b38bf56504"
          />
        </div>

        <button onClick={enviarNotificacao} disabled={loading}>
          {loading ? "Enviando..." : <> <FaPaperPlane /> Enviar via WhatsApp </>}
        </button>

        {mensagem && (
          <div className={`message ${mensagem.startsWith("✅") ? "success" : "error"}`}>
            {mensagem}
          </div>
        )}
      </div>
    </div>
  )
}

export default NotificacaoWhatsapp
